import { Icon } from "@nju/icons";
import { Text, TextStyleProps } from "@nju/ui";

interface IChangePaymentPendingInfoProps {
  tone: TextStyleProps["tone"];
}

export function ChangePaymentPendingInfo({
  tone,
}: IChangePaymentPendingInfoProps) {
  return (
    <Text
      className="items-center gap-2"
      display="flex"
      size={{
        "@onlyMobile": "s",
        "@fromTablet": "m",
      }}
      tone={tone}
    >
      zmiana metody płatności - w trakcie
      <div className="w-[23px] h-[23px]">
        <Icon height={23} name="spinner" width={23} />
      </div>
    </Text>
  );
}
